module.exports = __webpack_public_path__ + "static/media/event-4.b02d5b6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/event-4.jpg
// module id = 550
// module chunks = 0